import { useState } from 'react';
import { BellRing, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { isOpen, timeAgo } from '../qualityConfig';

const hint = (task) => (task.can_nudge ? 'Send a reminder'
    : `Reminder sent ${timeAgo(task.last_nudged_at)} · next one ${timeAgo(task.next_nudge_at)}`);

export const NudgeButton = ({ task, isOwn, onNudge, full = false }) => {
    const [busy, setBusy] = useState(false);
    if (isOwn || !isOpen(task)) return null;
    const click = async () => {
        setBusy(true);
        await onNudge(task);
        setBusy(false);
    };
    const disabled = busy || !task.can_nudge;
    const Icon = busy ? Loader2 : BellRing;
    return (
        <span title={hint(task)} className="inline-flex">
            <Button
                size={full ? 'default' : 'icon'}
                variant={full ? 'outline' : 'ghost'}
                onClick={click}
                disabled={disabled}
                aria-label={hint(task)}
                className={full ? 'border-amber-300 text-amber-700 hover:bg-amber-50 dark:border-amber-800/60 dark:text-amber-300 dark:hover:bg-amber-950/40' : ''}
                data-testid={full ? 'detail-nudge-button' : `task-nudge-${task.id}`}
            >
                <Icon className={`h-4 w-4 ${busy ? 'animate-spin' : 'text-amber-600 dark:text-amber-400'} ${full ? 'mr-2' : ''}`} />
                {full && (task.can_nudge ? 'Send reminder' : `Next reminder ${timeAgo(task.next_nudge_at)}`)}
            </Button>
        </span>
    );
};
